import { useCallback, useState } from 'react';
import { getBrandCode } from '../app/bootstrap';
import { STARBUCKSJAPAN } from '../constants/constants';

export const isPlayAllAnimationsFeatureEnabled = () => getBrandCode() !== STARBUCKSJAPAN;

export const useGifPlaybackToggle = (initialIsPlaying) => {
    const [isPlaying, setIsPlaying] = useState(initialIsPlaying);

    const play = useCallback(() => setIsPlaying(true), []);
    const pause = useCallback(() => setIsPlaying(false), []);

    return { isPlaying, play, pause };
};
